// extracted by mini-css-extract-plugin
export default {"MouseMove":"mousemove_MouseMove__qRW7z","large_circle":"mousemove_large_circle__W82ma"};